import BodyText from 'components/Luxkit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const ItemContainer = styled.div`
  padding: ${rem(8)};

  > * {
    margin-left: auto;
    margin-right: auto;
  }

  > * + * {
    margin-top: ${rem(4)};
  }

  > svg {
    height: ${rem(24)};
    width: 100%;
  }

  ${mediaQueryUp.tablet} {
    width: ${rem(267)};
    padding: ${rem(16)};

    > svg {
      height: ${rem(36)};
      width: 100%;
    }
  }
`

function TourV2BookWithConfidenceItem(props: Tours.V2OfferBookWithConfidenceItem) {
  const { title, description, Icon } = props

  return (
    <ItemContainer>
      <Icon type="primary" />
      <BodyText variant="large" weight="bold" align="center" >{title}</BodyText>
      <BodyText variant="medium" align="center" >{description}</BodyText>
    </ItemContainer>
  )
}

export default TourV2BookWithConfidenceItem
